// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApprovalSubject_ChangeEventFragmentDoc } from './ApprovalChangeEvent.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApprovalChangeEventBreakDownTabQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ApprovalChangeEventBreakDownTabQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, name: string, displayName: string, internalNote?: string | null | undefined, title: string, status: Types.ChangeEventStatus, originalTotalCostInCents: number, originalTotalPriceInCents: number, proposedTotalCostInCents: number, proposedTotalPriceInCents: number, budgetImpactInCents: number, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, proposedTotalCostInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, originalBudgetInCents: number, originalPriceInCents: number, revisedApprovedBudgetInCents: number, totalPriceInCents: number, item: { __typename?: 'Item', id: string, fullCode: string, displayName: string }, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', original: number, revisedInternalBudget: number } } }>, reason: { __typename?: 'ChangeEventReason', id: string, code: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string }, approval?: { __typename?: 'Approval', id: string } | null | undefined, predictedApprovers: Array<
      | { __typename?: 'Client', id: string, name: string }
      | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
      | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
    >, project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    , impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }>, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }> } };

export type ChangeEventBreakDownTab_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, proposedTotalCostInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, originalBudgetInCents: number, originalPriceInCents: number, revisedApprovedBudgetInCents: number, totalPriceInCents: number, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', original: number, revisedInternalBudget: number }, item: { __typename?: 'Item', id: string, displayName: string, fullCode: string } } };

export const ChangeEventBreakDownTab_ChangeEventLineItemFragmentDoc = gql`
    fragment ChangeEventBreakDownTab_ChangeEventLineItem on ChangeEventLineItem {
  id
  totalCostInCents
  totalPriceInCents
  proposedTotalCostInCents
  projectItem {
    id
    displayName
    budgetFinancials {
      original
      revisedInternalBudget
    }
    originalBudgetInCents
    originalPriceInCents
    revisedApprovedBudgetInCents
    totalPriceInCents
    item {
      id
      displayName
      fullCode
    }
  }
  proposedTotalCostInCents
}
    `;
export const ApprovalChangeEventBreakDownTabDocument = gql`
    query ApprovalChangeEventBreakDownTab($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...ApprovalSubject_ChangeEvent
    lineItems {
      ...ChangeEventBreakDownTab_ChangeEventLineItem
    }
  }
}
    ${ApprovalSubject_ChangeEventFragmentDoc}
${ChangeEventBreakDownTab_ChangeEventLineItemFragmentDoc}`;

/**
 * __useApprovalChangeEventBreakDownTabQuery__
 *
 * To run a query within a React component, call `useApprovalChangeEventBreakDownTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalChangeEventBreakDownTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalChangeEventBreakDownTabQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useApprovalChangeEventBreakDownTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables> & ({ variables: ApprovalChangeEventBreakDownTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>(ApprovalChangeEventBreakDownTabDocument, options);
      }
export function useApprovalChangeEventBreakDownTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>(ApprovalChangeEventBreakDownTabDocument, options);
        }
// @ts-ignore
export function useApprovalChangeEventBreakDownTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>;
export function useApprovalChangeEventBreakDownTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventBreakDownTabQuery | undefined, ApprovalChangeEventBreakDownTabQueryVariables>;
export function useApprovalChangeEventBreakDownTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>(ApprovalChangeEventBreakDownTabDocument, options);
        }
export type ApprovalChangeEventBreakDownTabQueryHookResult = ReturnType<typeof useApprovalChangeEventBreakDownTabQuery>;
export type ApprovalChangeEventBreakDownTabLazyQueryHookResult = ReturnType<typeof useApprovalChangeEventBreakDownTabLazyQuery>;
export type ApprovalChangeEventBreakDownTabSuspenseQueryHookResult = ReturnType<typeof useApprovalChangeEventBreakDownTabSuspenseQuery>;
export type ApprovalChangeEventBreakDownTabQueryResult = Apollo.QueryResult<ApprovalChangeEventBreakDownTabQuery, ApprovalChangeEventBreakDownTabQueryVariables>;